import React, {useState} from 'react';
import './Weather.css';
import axios from "axios"
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";






export default function Weather (props){
    
    const [weatherData, setWeatherData] = useState({ ready: false });
    const [city, setCity] = useState(props.defaultCity);
    function handleResponse(response){
        console.log (response.data);
        setWeatherData ({
            ready: true,
            coordinates: response.data.coord,
            temperature: response.data.main.temp,
            date: new Date(response.data.dt * 1000),
            wind: response.data.wind.speed,
            city: response.data.name,
            description: response.data.weather[0].description,
            humidity: response.data.main.humidity,
            feelsLike: response.data.main.feels_like,
            pressure: response.data.main.pressure,
            icon: response.data.weather[0].icon,
        });
        
       
    }

    function handleSubmit(event) {
        event.preventDefault();
        search();
      }
    
      function handleCityChange(event) {
        setCity(event.target.value);
      }
    
      function search() {
        const apiKey = "eadaf9d564268a9d29e613879a48803e";
        let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
        axios.get(apiUrl).then(handleResponse);
      }







    
if (weatherData.ready) {
    return (
     <div>   
          <form onSubmit={handleSubmit}>
          <div className="row d-flex justify-content-sm-end p-2">
            <div className="col-4 ">
              <input
                type="search"
                placeholder="Enter a city..."
                className="form-control"
                autoFocus="on"
                onChange={handleCityChange}
              />
            </div>
            <div className="col-sm-1">
              <input
                type="submit"
                value="🔍" 
                className="btn btn-primary w-100"
              />
            </div>
          </div>
        </form>
        

        <WeatherInfo data={weatherData} />
        <WeatherForecast coordinates={weatherData.coordinates} />
         
     </div>
        
       
    );

} else {
    search();


    return "Loading...";
}
}